export default __webpack_public_path__ + "static/media/faqs-img.e8cdf42a.png";